export const environment = {
  production: true,
  url_api: ''
};
